import { useMutation } from '@tanstack/react-query'

import { AddToCartRequest, CartViewModel, FailureEnvelop } from '@/types/api'

import { handleOpenCartLimit } from '@/features/cart-limit/utils/open-cart-limit-modal'

import { deemaTracker } from '@/components/deema/utils'

import fetchRequest from '@/app/_utils/fetch-request'

interface Params {
    atpId?: AddToCartRequest['atpId']
    itemProposalId?: AddToCartRequest['itemProposalId']
}

export default function usePostAddToCart({ atpId, itemProposalId }: Params) {
    return useMutation<CartViewModel, FailureEnvelop['errors']>({
        mutationFn: () =>
            fetchRequest({
                method: 'POST',
                serviceName: 'ntl',
                endpoint: '/carts/_my/items',
                body: { atpId, itemProposalId, qty: 1 },
            }),
        onSuccess: () => {
            deemaTracker.setCart()
        },
        onError: (error) => {
            const errorCode = error?.at?.(0)?.code

            switch (errorCode) {
                case 'cart_item_limitation':
                    handleOpenCartLimit()
                    return

                case 'item_proposal_change':
                    location.reload()
                    return

                default:
                    return ''
            }
        },
    })
}
